"use client";

import { MallApiError } from "../api";

/*
 * 훅끼리 쓰는 작은 도구 — 화면은 직접 쓰지 않습니다.
 */

/**
 * 검증 오류(3001)의 항목별 첫 문구를 `{필드: 문구}` 로. 없는 항목은 빈 문자열.
 * 🔴 키는 **요청 필드 이름(snake_case)** 그대로입니다 (`docs/base/07` §7-1).
 */
export function fieldErrorsOf(cause: unknown, names: readonly string[]): Record<string, string> {
  if (!(cause instanceof MallApiError)) return {};
  const out: Record<string, string> = {};
  for (const name of names) out[name] = cause.fieldError(name) ?? "";
  return out;
}
